import * as systemImages from '../../Resources/images/system';
import * as productImages from '../../Resources/images/product';
import { SelectionListItem } from '../../Components/Navigation/SelectionList';

export interface ApiMenuProductType {
  key: string;
  title: string;
}

export interface ApiMenuSystem {
  key: string;
  title: string;
  productTypes: ApiMenuProductType[];
}

const SYSTEM_BACKGROUNDS: Record<string, string> = {
  granulation: systemImages.granulation,
  flakers: systemImages.flakers,
};

export function mapMenuApiToState(menu: unknown): {
  systems: SelectionListItem[];
  productTypes: SelectionListItem[];
} {
  if (!Array.isArray(menu)) {
    return { systems: [], productTypes: [] };
  }

  const systems: SelectionListItem[] = [];
  const productTypes: SelectionListItem[] = [];

  for (const sys of menu as ApiMenuSystem[]) {
    if (!sys?.key) {
      continue;
    }
    systems.push({
      identifier: sys.key,
      title: sys.title,
      backgroundImage: SYSTEM_BACKGROUNDS[sys.key],
    });
    for (const pt of sys.productTypes || []) {
      if (!pt?.key) {
        continue;
      }
      productTypes.push({
        identifier: pt.key,
        title: pt.title,
        system: sys.key,
        backgroundImage: productImages[pt.key],
      });
    }
  }

  return { systems, productTypes };
}
